import { List, Record } from 'immutable';
import { NewRFI } from 'records/NewRFI';
import { ProjectDriveSelectedItem } from 'records/ProjectDriveSelectedItem';
import { IntegrationsSelectedItem } from 'records/IntegrationsSelectedItem';
import { StudioData } from 'records/RFI';
import { RFIAttachment } from 'records/RFIAttachment';
import { RFIFile } from 'records/RFIFile';
import { StudioProjectFileData } from 'records/StudioProjectFile';

export interface CreateRFIData {
  type: string;
  rfi: NewRFI;
  files: List<RFIFile>;
  fromDraft: boolean;
  rfiid: string | null;
  attachments: List<RFIAttachment>;
  removedAttachments: List<RFIAttachment>;
  expanded: boolean;
  viewerOverlay: boolean;
  projectDriveItems: List<ProjectDriveSelectedItem>;
  integrationItems: List<IntegrationsSelectedItem>;
  studioItems: List<StudioProjectFileData>;
  studioData: StudioData;
  canExpand: boolean;
}

const defaultValues: CreateRFIData = {
  type: 'CreateRFI',
  rfi: new NewRFI(),
  files: List<RFIFile>(),
  fromDraft: false,
  rfiid: null,
  attachments: List(),
  removedAttachments: List(),
  expanded: false,
  viewerOverlay: false,
  projectDriveItems: List(),
  integrationItems: List(),
  studioItems: List(),
  studioData: {
    studioSelectedFolders: [],
    selectedProject: '',
    studioCurrentProjectId: '',
    studioFolderParentId: '',
  },
  canExpand: false,
};

export const CreateRFIFactory = Record(defaultValues, 'CreateRFI');

export class CreateRFI extends CreateRFIFactory {}
